// Two readings of the same run: the numbers, and the documents they become.
export const LENS = { numbers: "numbers", statements: "statements" } as const;
export type Lens = (typeof LENS)[keyof typeof LENS];
// The product's own words. "Statements" is the internal name for the documents
// technicians receive; everywhere the owner meets them they are PayPacks,
// spelled with the capital P the rest of the product uses.
export const LENS_LABEL: Record<Lens, string> = {
  numbers: "Grid",
  statements: "PayPacks",
};
